import React from "react";
import { ChatBox } from "../../../../feature-components/ChatBox/ChatBox.tsx";
import { FilterChips } from "./FilterChips.tsx";
import { KnowledgeSource } from "./KnowledgeSource.tsx";

export const InsightsAgentChatBox = (props: {
  onSubmit: (value: string) => void;
  processing?: boolean;
  submitDisabled?: boolean;
  knowledgeSource?: string;
  filterDialogComponent?: React.ReactNode;
  filterChips?: React.ReactNode;
  regenerateButton?: React.ReactNode;
  knowledgeSourceDropdown?: React.ReactNode;
}) => (
  <ChatBox
    onSubmit={props.onSubmit}
    processing={props.processing}
    submitDisabled={props.submitDisabled}
  >
    {props.knowledgeSource !== undefined &&
    props.knowledgeSource.length !== 0 ? (
      <KnowledgeSource knowledgeSource={props.knowledgeSource} />
    ) : (
      <>{props.knowledgeSourceDropdown}</>
    )}
    <div>{props.filterDialogComponent}</div>
    <FilterChips filterChips={props.filterChips} />
    <div>{props.regenerateButton}</div>
  </ChatBox>
);
